/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    DownloadTemplate(domainId) {
        return HttpService.get(
            environment.API_IMPORT_DS_REQUEST + `/template/${domainId}`,
            { responseType: 'blob' }
        );
    },
    DownloadTemplateId(id) {
        return HttpService.get(
            environment.API_IMPORT_DS_REQUEST + `/history/${id}`,
            { responseType: 'blob' }
        );
    },
    UploadDsRequest(payload, onUploadProgress) {
        return HttpService.post(
            environment.API_IMPORT_DS_REQUEST + `/template`,
            payload,
            {
                onUploadProgress,
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                },
            }
        );
    },
    ImportHistory(params) {
        return HttpService.get(environment.API_IMPORT_DS_REQUEST + `/history`, {
            params,
        });
    },
};
